export enum IdentityVerificationDocumentSides {
  FRONT = "front",
  BACK = "back",
}
